module.exports = __webpack_public_path__ + "static/media/whichThinnerRegularBloodTests.48cf53b8.mp3";